import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Thermometer } from "lucide-react";
import { toast } from "sonner";
import { apiError, fmtDate } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

export default function Krankmeldung() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ start_date: "", end_date: "", note: "" });

  const load = async () => setRows((await api.get("/sick-leaves")).data || []);
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.start_date || !form.end_date) return toast.error("Bitte Zeitraum wählen");
    try {
      await api.post("/sick-leaves", form);
      toast.success("Krankmeldung übermittelt");
      setOpen(false);
      setForm({ start_date: "", end_date: "", note: "" });
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div>
      <PageHeader
        title="Krankmeldung"
        subtitle="Melde Krankheitstage an deine Firma."
        testid="krank-header"
        action={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button data-testid="sick-open" className="brand-bg text-white hover:opacity-90"><Plus className="h-4 w-4 mr-2" /> Krankmeldung</Button>
            </DialogTrigger>
            <DialogContent data-testid="sick-dialog">
              <DialogHeader><DialogTitle>Krankmeldung</DialogTitle></DialogHeader>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-2"><Label>Von</Label><Input type="date" data-testid="sick-start" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} /></div>
                  <div className="space-y-2"><Label>Bis</Label><Input type="date" data-testid="sick-end" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} /></div>
                </div>
                <div className="space-y-2"><Label>Anmerkung</Label><Textarea data-testid="sick-note" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Optional" /></div>
              </div>
              <DialogFooter><Button onClick={submit} data-testid="sick-submit" className="brand-bg text-white hover:opacity-90">Übermitteln</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />

      <div className="grid gap-3">
        {rows.length === 0 ? (
          <Card className="border-slate-200 rounded-xl"><EmptyState icon={Thermometer} title="Keine Krankmeldungen" testid="krank-empty" /></Card>
        ) : (
          rows.map((r) => (
            <Card key={r.id} className="p-4 border-slate-200 rounded-xl" data-testid={`sick-row-${r.id}`}>
              <div className="font-medium text-slate-900">{fmtDate(r.start_date)} – {fmtDate(r.end_date)}</div>
              {r.note && <div className="text-sm text-slate-500 mt-0.5">{r.note}</div>}
            </Card>
          ))
        )}
      </div>
    </div>
  );
}
